<template>
  <div>
    <el-dialog
      :title="$t('components.DataDisplay.9398862-0')"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div v-loading="loading">
        <!-- 选项卡导航 -->
        <el-tabs v-model="activeTab">
          <el-tab-pane :label="$t('components.DataDisplay.9398862-1')" name="all"></el-tab-pane>
          <el-tab-pane :label="$t('components.DataDisplay.9398862-2')" name="stats"></el-tab-pane>
        </el-tabs>

        <!-- 统计数据卡片 -->
        <div class="statistics-container" v-if="activeTab === 'stats'" v-loading="statsLoading">
          <!-- 问题统计详情 -->
          <div v-if="statisticsData && !statsLoading" class="question-stats-container">
            <!-- 选择题统计 -->
            <div v-for="(stats, questionTitle) in statisticsData.questionOptionStatistics" :key="questionTitle" class="question-stat-item">
              <h4>{{ questionTitle }} <el-tag size="mini" type="info">{{ $t('components.DataDisplay.9398862-3') }}</el-tag></h4>

              <!-- 表格展示 -->
              <el-table
                v-if="!questionDisplayTypes[questionTitle] || questionDisplayTypes[questionTitle] === 'table'"
                :data="formatOptionStats(stats)"
                style="width: 100%" border size="mini"
              >
                <el-table-column prop="option" :label="$t('components.DataDisplay.9398862-4')"></el-table-column>
                <el-table-column prop="count" :label="$t('components.DataDisplay.9398862-5')" width="80"></el-table-column>
                <el-table-column prop="percentage" :label="$t('components.DataDisplay.9398862-6')" width="200">
                  <template slot-scope="scope">
                    <el-progress class="progress-bar" :percentage="scope.row.percentage" :stroke-width="10" :format="formatPercentage"></el-progress>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 图表容器 -->
              <div
                v-else
                :ref="'chart_' + questionTitle"
                class="chart-container"
                style="width: 100%; height: 300px; margin-top: 10px;"
              ></div>

              <div class="question-footer">
                <span>{{ $t('components.DataDisplay.9398862-7') }} {{ calculateTotalOptionResponses(stats) }}</span>
                 <div class="chart-buttons">
                    <el-button type="text" size="mini" icon="el-icon-s-grid" @click="switchDisplay(questionTitle, 'table')">{{ $t('components.DataDisplay.9398862-8') }}</el-button>
                    <el-button type="text" size="mini" icon="el-icon-pie-chart" @click="switchDisplay(questionTitle, 'pie')">{{ $t('components.DataDisplay.9398862-9') }}</el-button>
                    <el-button type="text" size="mini" icon="el-icon-odometer" @click="switchDisplay(questionTitle, 'doughnut')">{{ $t('components.DataDisplay.9398862-10') }}</el-button>
                    <el-button type="text" size="mini" icon="el-icon-data-analysis" @click="switchDisplay(questionTitle, 'bar')">{{ $t('components.DataDisplay.9398862-11') }}</el-button>
                    <el-button type="text" size="mini" icon="el-icon-bottom-right" @click="switchDisplay(questionTitle, 'line')">{{ $t('components.DataDisplay.9398862-12') }}</el-button>
                  </div>
              </div>
            </div>

            <!-- 填空题统计 -->
            <div v-for="(keywords, questionTitle) in statisticsData.questionKeywordStatistics" :key="questionTitle" class="question-stat-item">
               <h4>{{ questionTitle }} <el-tag size="mini" type="warning">{{ $t('components.DataDisplay.9398862-13') }}</el-tag></h4>
               <div class="keyword-section">
                  <!-- 使用 vue-wordcloud 组件 -->
                  <wordcloud
                    v-if="Array.isArray(keywords) && keywords.length > 0"
                    :data="formatKeywords(keywords)"
                    nameKey="name"
                    valueKey="value"
                    :color="myColors"
                    :showTooltip="false"
                    font="Roboto"
                    :fontSize="[40,80]"
                  />
                  <div v-else class="empty-keywords">
                    {{ $t('components.DataDisplay.9398862-14') }}
                  </div>
               </div>
            </div>
          </div>
           <el-empty v-else-if="!statsLoading" :description="$t('components.DataDisplay.9398862-15')"></el-empty>
        </div>

        <!-- 表格数据展示 -->
        <div class="data-content" v-if="activeTab === 'all'">
          <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="nickName" :label="$t('components.DataDisplay.9398862-16')" width="180"></el-table-column>
            <el-table-column prop="target" :label="$t('components.DataDisplay.9398862-17')" width="180">
              <template slot-scope="scope">
                {{ scope.row.target || $t('components.DataDisplay.9398862-18') }}
              </template>
            </el-table-column>
            <el-table-column prop="email" :label="$t('components.DataDisplay.9398862-19')">
              <template slot-scope="scope">
                {{ scope.row.email || scope.row.userName || $t('components.DataDisplay.9398862-18') }}
              </template>
            </el-table-column>
            <el-table-column prop="rating" :label="$t('components.DataDisplay.9398862-20')"></el-table-column>
            <el-table-column prop="createTime" :label="$t('components.DataDisplay.9398862-21')" width="180"></el-table-column>
            <el-table-column :label="$t('components.DataDisplay.9398862-22')" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="viewDetail(scope.row)">{{ $t('components.DataDisplay.9398862-23') }}</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页组件 -->
          <div class="pagination-container">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('components.DataDisplay.9398862-24') }}</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog
      :title="$t('components.DataDisplay.9398862-27')"
      :visible.sync="detailDialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div v-loading="detailLoading" class="detail-dialog-content">
        <div v-if="currentDetail">
          <div v-for="item in currentDetail" :key="item.id" class="detail-item">
            <p class="question-title">{{ $t('components.DataDisplay.9398862-28') }}{{ item.questionTitle || $t('components.DataDisplay.9398862-29') }}</p>
            <div class="answer-section">
              <template v-if="['text', 'textarea'].includes(item.questionType)">
                <p>{{ item.answer || $t('components.DataDisplay.9398862-18') }}</p>
              </template>
              <template v-else-if="item.questionType === 'rating'">
                 <p>{{ $t('components.DataDisplay.9398862-20') }}：{{ item.answer || $t('components.DataDisplay.9398862-31') }}</p>
                 <p v-if="item.content">{{ $t('components.DataDisplay.9398862-32') }}{{ item.content }}</p>
              </template>
              <template v-else-if="['single_choice', 'multiple_choice'].includes(item.questionType)">
                <p>{{ $t('components.DataDisplay.9398862-33') }}</p>
                <ul v-if="item.responseOptions && item.responseOptions.length > 0" style="margin: 0; padding-left: 20px;">
                  <li v-for="option in item.responseOptions" :key="option.id">
                    {{ option.optionTitle }}
                  </li>
                </ul>
                 <p v-else-if="item.answer">{{ item.answer }}</p>
                <p v-else>{{ $t('components.DataDisplay.9398862-34') }}</p>
              </template>
              <!-- 处理其他未知或特殊类型 -->
              <template v-else>
                 <p>{{ $t('components.DataDisplay.9398862-33') }}{{ item.answer || 'N/A' }}</p>
                 <p v-if="item.content">{{ $t('components.DataDisplay.9398862-32') }}{{ item.content }}</p>
                 <p v-if="item.responseOptions && item.responseOptions.length > 0" style="margin: 0; padding-left: 20px;">
                   {{ $t('components.DataDisplay.9398862-35') }}
                   <ul style="margin: 0; padding-left: 15px;">
                     <li v-for="option in item.responseOptions" :key="option.id">
                       {{ option.optionTitle }} (ID: {{ option.optionsId }})
                     </li>
                   </ul>
                 </p>
              </template>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="detailDialogVisible = false">{{ $t('components.DataDisplay.9398862-24') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // 导入 vue-wordcloud
  import wordcloud from 'vue-wordcloud';
  // 导入 ECharts
  import * as echarts from 'echarts/core';
  import {
    TooltipComponent,
    LegendComponent,
    GridComponent
  } from 'echarts/components';
  import {
    PieChart,
    BarChart,
    LineChart
  } from 'echarts/charts';
  import { LabelLayout } from 'echarts/features';
  import { CanvasRenderer } from 'echarts/renderers';

  echarts.use([
    TooltipComponent,
    LegendComponent,
    GridComponent,
    PieChart,
    BarChart,
    LineChart,
    CanvasRenderer,
    LabelLayout
  ]);

  export default {
    name: "DataDisplay",
    // 注册组件，使用 'wordcloud' 作为组件名
    components: {
      wordcloud
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      surveyId: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        activeTab: "all",
        tableData: [],
        currentPage: 1,
        pageSize: 10,
        total: 0,
        detailDialogVisible: false,
        currentDetail: null,
        detailLoading: false,
        statisticsData: null,
        statsLoading: false,
        myColors: [ '#8085e9', '#f7a35c','#e4d354', '#7cb5ec','#a4f194',"#434348","#f15c80","#2b908f"],
        questionDisplayTypes: {}, // 存储每个问题的显示类型 ('table', 'pie', 'doughnut', 'bar', 'line')
        chartInstances: {}, // 存储 ECharts 实例
      };
    },
    watch: {
      visible(val) {
        this.dialogVisible = val;
        if (val && this.surveyId) {
          if (this.activeTab === 'all') {
            this.fetchTableData();
          } else if (this.activeTab === 'stats') {
            this.fetchStatisticsData();
          }
        }
      },
      dialogVisible(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      activeTab(newTab, oldTab) {
        if (this.dialogVisible && this.surveyId) {
           if (newTab === 'all' && (!this.tableData || !this.tableData.length)) { // 检查 tableData 是否为空数组或null
             this.fetchTableData();
           } else if (newTab === 'stats') {
             if (!this.statisticsData) {
               this.fetchStatisticsData();
             } else {
               // 数据已存在，可能需要重新初始化图表或显示状态
               this.$nextTick(() => { // 确保DOM更新完毕
                  this.initializeDisplayTypes();
                  // 如果有图表已经切换，需要重新渲染
                  Object.entries(this.questionDisplayTypes).forEach(([title, type]) => {
                      if (type !== 'table') {
                          this.renderChart(title, type);
                      }
                  });
               });
             }
           }
        }
         // 当从 stats 切换走时，销毁图表
        if (oldTab === 'stats') {
           this.disposeCharts();
        }
      }
    },
    methods: {
      handleClose() {
        this.disposeCharts(); // 关闭弹窗时销毁图表
        this.dialogVisible = false;
      },
      async fetchTableData() {
        if (!this.surveyId) return;
        this.loading = true;
        try {
          const tableResponse = await this.$api.request(this.$url.Survey.data, this.$method.get, {
            surveyId: this.surveyId,
            pageIndex: this.currentPage,
            pageSize: this.pageSize
          });

          if (tableResponse.code === 0 && tableResponse.data) {
            this.tableData = tableResponse.data.records || [];
            this.total = parseInt(tableResponse.data.total || 0);
            this.currentPage = parseInt(tableResponse.data.current || 1);
            this.pageSize = parseInt(tableResponse.data.size || 10);
          } else {
            this.$message.error(tableResponse.msg || this.$t('components.DataDisplay.9398862-36'));
          }
        } catch (error) {
           console.error(this.$t('components.DataDisplay.9398862-37'), error);
           this.$message.error(this.$t('components.DataDisplay.9398862-38'));
        } finally {
           this.loading = false;
        }
      },
      async fetchStatisticsData() {
        if (!this.surveyId) return;
        this.statsLoading = true;
        this.statisticsData = null;
        try {
          const statsResponse = await this.$api.request(this.$url.Survey.answerByPage, this.$method.get, {
            surveyId: this.surveyId
          });

          if (statsResponse.code === 0 && statsResponse.data) {
            this.statisticsData = statsResponse.data;
            this.initializeDisplayTypes(); // 初始化显示类型
          } else {
             this.$message.warning(statsResponse.msg || this.$t('components.DataDisplay.9398862-39'));
          }
        } catch (error) {
          console.error(this.$t('components.DataDisplay.9398862-40'), error);
          this.$message.error(this.$t('components.DataDisplay.9398862-41'));
        } finally {
          this.statsLoading = false;
        }
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.fetchTableData();
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchTableData();
      },
      async viewDetail(row) {
        if (!row || !row.id) {
          this.$message.warning(this.$t('components.DataDisplay.9398862-44'));
          return;
        }
        this.currentDetail = null;
        this.detailDialogVisible = true;
        this.detailLoading = true;
        try {
          const res = await this.$api.request(this.$url.Survey.answerByPeople, this.$method.get, {
            surveyResponseId: row.id
          });
          if (res.code === 0) {
            this.currentDetail = res.data;
          } else {
            this.$message.error(res.msg || this.$t('components.DataDisplay.9398862-45'));
            this.detailDialogVisible = false;
          }
        } catch (error) {
          console.error(this.$t('components.DataDisplay.9398862-46'), error);
          this.$message.error(this.$t('components.DataDisplay.9398862-46'));
          this.detailDialogVisible = false;
        } finally {
           this.detailLoading = false;
        }
      },
      formatOptionStats(stats) {
        return Object.entries(stats).map(([option, data]) => ({
          option: option,
          count: data.count,
          percentage: data.percentage
        }));
      },
      calculateTotalOptionResponses(stats) {
        return Object.values(stats).reduce((sum, data) => sum + data.count, 0);
      },
      formatPercentage(percentage) {
        return `${percentage.toFixed(2)}%`;
      },
      formatKeywords(keywords) {
        if (!Array.isArray(keywords)) {
          return [];
        }
        return keywords.map(item => ({
          name: String(item.keyword || ''),
          value: Number(item.count || 0)
        }));
      },

      // ---- 图表相关方法 ----

      // 初始化显示类型
      initializeDisplayTypes() {
        if (this.statisticsData && this.statisticsData.questionOptionStatistics) {
          const types = {};
          Object.keys(this.statisticsData.questionOptionStatistics).forEach(title => {
            // 保留之前的选择，如果不存在则默认为 table
            types[title] = this.questionDisplayTypes[title] || 'table';
          });
          this.questionDisplayTypes = types;
        }
         // 清理之前的图表实例 (避免重复渲染)
        this.disposeCharts();
      },

      // 切换显示类型
      switchDisplay(questionTitle, type) {
         // 如果已经是目标类型，则不处理
        if (this.questionDisplayTypes[questionTitle] === type) {
          return;
        }

        // 先销毁旧图表（如果存在）
        this.disposeChart(questionTitle);

        // 更新显示类型
        this.$set(this.questionDisplayTypes, questionTitle, type); // 使用 $set 保证响应性

        // 如果切换到图表类型，则在下一个 tick 渲染
        if (type !== 'table') {
          this.$nextTick(() => {
            this.renderChart(questionTitle, type);
          });
        }
      },

      // 渲染图表
      renderChart(questionTitle, type) {
         const chartRef = this.$refs['chart_' + questionTitle];
         if (!chartRef || chartRef.length === 0) {
             console.warn(`Chart container not found for question: ${questionTitle}`);
             return;
         }
         const chartDom = Array.isArray(chartRef) ? chartRef[0] : chartRef; // $refs 可能返回数组
         if(!chartDom) {
             console.warn(`Chart DOM element not found for question: ${questionTitle}`);
             return;
         }

        // 销毁可能存在的旧实例，以防万一
        this.disposeChart(questionTitle);

        const myChart = echarts.init(chartDom);
        this.chartInstances[questionTitle] = myChart; // 存储实例

        const stats = this.statisticsData.questionOptionStatistics[questionTitle];
        const chartData = Object.entries(stats).map(([option, data]) => ({
          name: option,
          value: data.count
        }));
        const legendData = chartData.map(item => item.name);

        let option;

        switch (type) {
          case 'pie':
            option = {
              tooltip: { trigger: 'item', formatter: '{b} : {c} ({d}%)' },
              legend: { type: 'scroll', orient: 'vertical', right: 10, top: 20, bottom: 20, data: legendData },
              series: [{ name: this.$t('components.DataDisplay.9398862-47'), type: 'pie', radius: ['0%', '70%'], center: ['50%', '60%'], data: chartData, emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0, 0, 0, 0.5)' } } }]
            };
            break;
          case 'doughnut':
             option = {
              tooltip: { trigger: 'item', formatter: '{b} : {c} ({d}%)' },
              legend: { type: 'scroll', orient: 'vertical', right: 10, top: 20, bottom: 20, data: legendData },
              series: [{ name: this.$t('components.DataDisplay.9398862-47'), type: 'pie', radius: ['40%', '70%'], center: ['50%', '60%'], avoidLabelOverlap: false, label: { show: false, position: 'center' }, emphasis: { label: { show: true, fontSize: '16', fontWeight: 'bold' } }, labelLine: { show: false }, data: chartData }]
            };
            break;
          case 'bar':
            option = {
              tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
              grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
              xAxis: [{ type: 'category', data: legendData, axisTick: { alignWithLabel: true } }],
              yAxis: [{ type: 'value' }],
              series: [{ name: this.$t('components.DataDisplay.9398862-48'), type: 'bar', barWidth: '60%', data: chartData.map(item => item.value) }]
            };
            break;
          case 'line':
             option = {
              tooltip: { trigger: 'axis' },
               grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
              xAxis: { type: 'category', boundaryGap: false, data: legendData },
              yAxis: { type: 'value' },
              series: [{ name: this.$t('components.DataDisplay.9398862-48'), type: 'line', stack: 'Total', data: chartData.map(item => item.value), areaStyle: {} }] // 添加 areaStyle 使其成为面积图
            };
            break;
          default:
            console.warn('Unsupported chart type:', type);
            return;
        }

        option && myChart.setOption(option);

        // 添加窗口大小调整监听
        window.addEventListener('resize', this.resizeChartHandler(myChart));
      },

      // 返回一个处理resize的函数，避免监听器this指向问题
      resizeChartHandler(chartInstance) {
          // 使用防抖优化resize
          let timeout;
          return () => {
              if (timeout) {
                  clearTimeout(timeout);
              }
              timeout = setTimeout(() => {
                  if(chartInstance && !chartInstance.isDisposed()){
                     chartInstance.resize();
                  }
              }, 100); // 100ms防抖
          };
      },

      // 销毁单个图表
      disposeChart(questionTitle) {
        const chart = this.chartInstances[questionTitle];
        if (chart && !chart.isDisposed()) {
           // 尝试移除resize监听，尽管没有直接存储handler，但这是最佳实践
           // 注意: 实际移除需要存储 resizeChartHandler 返回的函数引用，这里简化处理
          window.removeEventListener('resize', chart.resize); // 尝试移除，可能不精确
          chart.dispose();
        }
        delete this.chartInstances[questionTitle]; // 从实例记录中移除
      },

      // 销毁所有图表
      disposeCharts() {
        Object.keys(this.chartInstances).forEach(title => {
          this.disposeChart(title);
        });
         this.chartInstances = {}; // 重置实例对象
      }
    },
    beforeDestroy() {
       this.disposeCharts(); // 组件销毁前销毁图表
    },
  };
</script>

<style lang="scss" scoped>
  .statistics-container {
    margin-bottom: 20px;
    min-height: 150px;
  }

  .statistics-number {
    font-size: 24px;
    font-weight: bold;
    color: #409eff;
    text-align: center;
    padding: 10px 0;
  }

  .question-stats-container {
     margin-top: 20px;
  }

  .question-stat-item {
    background-color: #f9f9f9;
    padding: 15px;
    margin-bottom: 20px;
    border: 1px solid #eaeaeb;
    border-radius: 4px;

    h4 {
      margin-top: 0;
      margin-bottom: 15px;
      font-size: 16px;
      color: #303133;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .question-footer {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #909399;

     .chart-buttons button {
        margin-left: 5px; // 调整按钮间距
        padding: 0 4px; // 调整按钮内边距
     }
  }

  .chart-container {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    margin-top: 15px; /* 根据需要调整 */
    padding: 10px;
    background-color: #fff;
  }

  .keyword-section {
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 15px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
  }

  .keyword-actions {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      button {
         margin-bottom: 5px;
         padding: 3px 0;
         margin-left: 0 !important;
      }
  }

  .data-content {
    min-height: 300px;
    margin-top: 20px;
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .detail-dialog-content {
    min-height: 200px;
    max-height: 60vh;
    overflow-y: auto;
    padding: 10px;
  }

  .detail-item {
    margin-bottom: 18px;
    padding-bottom: 15px;
    border-bottom: 1px dashed #e0e0e0;
  }
  .detail-item:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 5px;
  }

  .question-title {
    font-weight: bold;
    margin-bottom: 8px;
    color: #303133;
  }

  .answer-section {
    padding-left: 15px;
    color: #606266;
    font-size: 14px;
    line-height: 1.6;
  }
  .answer-section p,
  .answer-section ul {
    margin: 5px 0;
  }
  .answer-section ul {
    padding-left: 25px;
  }

  .empty-keywords {
    height: 200px;
    width: 100%; /* 调整词云宽度适应容器 */
    border: 1px dashed #dcdfe6;
    /* margin-right: 15px; */ /* 移除右边距 */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 14px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  /* 确保 wordcloud 组件也能适应容器 */
  ::v-deep .keyword-section wordcloud {
      width: 100% !important;
      height: 300px !important; /* 或者根据需要设置高度 */
  }
 ::v-deep .progress-bar .el-progress__text{
 font-size: 12px !important;
 }
</style>
